(() => {
  const roots = Array.from(document.querySelectorAll('[data-self-help-faq]'));
  if (!roots.length) return;

  const triage = {
    wallet: {
      title: 'Start with wallet access',
      copy: 'Open the Wallet notes, connect from the correct browser or wallet app, and use the Disconnect wallet control if you need to switch accounts.',
      filter: 'wallet'
    },
    token: {
      title: 'Check NFT and gate pairing',
      copy: 'Open the NFT notes, make sure the holder wallet is connected, and verify that you entered through the correct gate for the dashboard or VR gallery.',
      filter: 'nft'
    },
    gate: {
      title: 'Check redeem or redirect rules',
      copy: 'Open the Tokengate notes if a product link redirects, a redeem button is still waiting, or a protected page sends you back through the gate.',
      filter: 'tokengate'
    }
  };

  roots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const cards = Array.from(root.querySelectorAll('[data-faq-card]'));
    const search = root.querySelector('[data-faq-search]');
    const filters = Array.from(root.querySelectorAll('[data-filter]'));
    const emptyState = root.querySelector('[data-empty-state]');
    const answer = root.querySelector('[data-triage-answer]');
    const progressLabel = root.querySelector('[data-progress-label]');
    const progressFill = root.querySelector('[data-progress-fill]');
    let activeFilter = 'all';

    function applyFilters() {
      const query = (search?.value || '').trim().toLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const categoryMatch = activeFilter === 'all' || card.dataset.category === activeFilter;
        const searchMatch = !query || String(card.dataset.search || '').toLowerCase().includes(query);
        const isVisible = categoryMatch && searchMatch;
        card.classList.toggle('is-hidden', !isVisible);
        if (isVisible) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.classList.toggle('is-visible', visibleCount === 0);
      }
    }

    function setFilter(filter) {
      activeFilter = filter;
      filters.forEach((button) => {
        const isActive = button.dataset.filter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      applyFilters();
    }

    function updateProgress() {
      const solved = cards.filter((card) => card.classList.contains('is-solved')).length;
      const total = cards.length || 1;
      if (progressLabel) {
        progressLabel.textContent = `${solved} ${solved === 1 ? 'fix' : 'fixes'} marked solved`;
      }
      if (progressFill) {
        progressFill.style.width = `${Math.round((solved / total) * 100)}%`;
      }
    }

    function setTriageAnswer(pick) {
      if (!answer || !pick) return;
      answer.replaceChildren();
      const strong = document.createElement('strong');
      strong.textContent = pick.title;
      answer.appendChild(strong);
      answer.append(' ' + pick.copy);
    }

    filters.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
      button.addEventListener('click', () => setFilter(button.dataset.filter || 'all'));
    });

    search?.addEventListener('input', applyFilters);

    root.querySelectorAll('[data-triage]').forEach((button) => {
      button.addEventListener('click', () => {
        const pick = triage[button.dataset.triage || ''];
        if (!pick) return;
        setTriageAnswer(pick);
        setFilter(pick.filter);
      });
    });

    root.querySelectorAll('[data-copy-fix]').forEach((button) => {
      button.addEventListener('click', async () => {
        const originalText = button.textContent;
        const fix = button.dataset.copyFix || '';
        try {
          await navigator.clipboard.writeText(fix);
          button.textContent = 'Copied';
        } catch (_error) {
          button.textContent = 'Copy failed';
        }
        window.setTimeout(() => {
          button.textContent = originalText;
        }, 1600);
      });
    });

    root.querySelectorAll('[data-solved-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-faq-card]');
        if (!card) return;
        const isSolved = card.classList.toggle('is-solved');
        button.textContent = isSolved ? 'Solved' : 'Mark solved';
        updateProgress();
      });
    });

    updateProgress();
    applyFilters();
  });
})();
